import script from "./LinkFacilitiesToGroupModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LinkFacilitiesToGroupModal.vue?vue&type=script&setup=true&lang=ts"

import "./LinkFacilitiesToGroupModal.vue?vue&type=style&index=0&id=2364eb57&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2364eb57"]])

export default __exports__